var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState } from "react";
import { FormGroup, Input } from "reactstrap";

var CustomTextArea = function CustomTextArea(_ref) {
  var value = _ref.value,
      name = _ref.name,
      label = _ref.label,
      invalid = _ref.invalid,
      valid = _ref.valid,
      innerRef = _ref.innerRef,
      htmlFor = _ref.htmlFor,
      inline = _ref.inline,
      id = _ref.id,
      key = _ref.key,
      size = _ref.size,
      bsSize = _ref.bsSize,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      placeholder = _ref.placeholder,
      showCharCounter = _ref.showCharCounter,
      onChange = _ref.onChange,
      onInput = _ref.onInput,
      required = _ref.required,
      disabled = _ref.disabled;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      charCounter = _useState2[0],
      setCharCounter = _useState2[1];

  var handleChangeCharCounter = function handleChangeCharCounter(e) {
    setCharCounter(e.target.value.length);
    onChange && onChange(e);
    onInput && onInput(e);
  };

  return React.createElement(
    FormGroup,
    null,
    React.createElement(Input, {
      value: value,
      name: name,
      label: label,
      onChange: handleChangeCharCounter,
      onInput: handleChangeCharCounter,
      invalid: invalid,
      valid: valid,
      innerRef: innerRef,
      htmlFor: htmlFor,
      inline: inline,
      id: id,
      key: key,
      size: size,
      bsSize: bsSize,
      type: "textarea",
      className: "custom-textarea",
      maxLength: maxLength,
      minLength: minLength,
      placeholder: placeholder,
      disabled: disabled,
      required: required
    }),
    showCharCounter && React.createElement(
      "span",
      {
        style: {
          fontStyle: "italic",
          color: charCounter === maxLength ? "var(--danger)" : ""
        }
      },
      "Caracteres: ",
      "" + charCounter + (maxLength ? "/" + maxLength : "")
    )
  );
};

export default CustomTextArea;